import React from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _includes from 'lodash/includes';
import PropTypes from 'prop-types';
// Core components
import Table from 'components/core/table/Table';
import TableHead from 'components/core/table/TableHead';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Models
import mApn from 'models/apn';
// Custom
import { simcardGroupDataShape, apnDataShape } from 'constants/PropTypesShapes';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';

const GroupItem = ({ simcardGroup, apns, onApnSelection }) => (
  <CollapseBoxTemplate
    initiallyClosed
    title={simcardGroup.name}
    titleSize="sm"
  >
    <Table
      hasElements
      head={(
        <TableHead
          columns={mApn.columns}
          adjustForCheckbox
        />
      )}
    >
      {!!apns && _map(apns, (apn) => (
        <TableRow
          key={_toString(apn.id)}
          selected={_includes(simcardGroup.apns, apn.id)}
          onClick={() => onApnSelection(simcardGroup, apn.id)}
        >
          <TableCell role="checkbox" selected={_includes(simcardGroup.apns, apn.id)} />
          <TableCell>{apn.name}</TableCell>
          <TableCell>{apn.identifier}</TableCell>
          <TableCell>{apn.login}</TableCell>
          <TableCell>{apn.password}</TableCell>
        </TableRow>
      ))}
    </Table>
  </CollapseBoxTemplate>
);

GroupItem.propTypes = {
  simcardGroup: simcardGroupDataShape.isRequired,
  apns: PropTypes.arrayOf(apnDataShape),
  onApnSelection: PropTypes.func.isRequired,
};

GroupItem.defaultProps = {
  apns: null,
};

const mapStateToProps = (state) => ({
  apns: state.apn.list.elements.data,
});

module.exports = connect(
  mapStateToProps,
  null,
)(GroupItem);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/groups/GroupItem.js